import { render, staticRenderFns } from "./IceLabel.vue?vue&type=template&id=1b652e8d&scoped=true"
import script from "./IceLabel.vue?vue&type=script&lang=js"
export * from "./IceLabel.vue?vue&type=script&lang=js"
import style0 from "./IceLabel.vue?vue&type=style&index=0&id=1b652e8d&lang=css"
import style1 from "./IceLabel.vue?vue&type=style&index=1&id=1b652e8d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b652e8d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\G\\YT\\mes-project-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b652e8d')) {
      api.createRecord('1b652e8d', component.options)
    } else {
      api.reload('1b652e8d', component.options)
    }
    module.hot.accept("./IceLabel.vue?vue&type=template&id=1b652e8d&scoped=true", function () {
      api.rerender('1b652e8d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/IceLabel.vue"
export default component.exports